export { countDisabledDevices, getDeviceData } from '../sync-configuration-modal/SyncConfigurationModal.util';
